<script setup lang="ts">
import { Color } from "@/types/components/Base/Color";
import { computed } from "vue";

export type Props = {
  tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "div" | "span";
  size?: 1 | 2 | 3 | 4 | 5 | 6 | "small";
  weight?: "medium" | "semibold" | "bold" | "bolder" | "light" | "lighter";
  alignment?: "start" | "center" | "end";
  color?: Color;
  uppercase?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  tag: "h1",
  size: 4,
  weight: "semibold",
  alignment: "start",
  color: "dark",
  uppercase: false,
});

const fontSize = computed(() =>
  props.size === "small" ? "small" : `fs-${props.size}`
);

const tag = computed(() => props.tag);
</script>

<template>
  <component
    :is="tag"
    :class="[
      'headline',
      fontSize,
      weight && `fw-${weight}`,
      alignment && `text-${alignment}`,
      color && `text-${color}`,
      { 'text-uppercase': uppercase },
    ]"
  >
    <slot></slot>
  </component>
</template>

<style scoped>
.headline {
  margin-bottom: 1rem;
}
</style>
